import { render, staticRenderFns } from "./PaymentHx.vue?vue&type=template&id=333f5e00"
import script from "./PaymentHx.vue?vue&type=script&lang=js"
export * from "./PaymentHx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports